
export class Access {

	exists: boolean;
	hasPassAccess: boolean;
	passAccessBlocked: boolean;
	hasPassTransaction: boolean;
	hasSecurityQuestions: boolean;
	acceptTerms: boolean;
	termsText: string;

	constructor() {}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/models/access.ts